export default __webpack_public_path__ + "static/media-sm-44557b729b76e823ef0f8d5ab38bf8b4.png";